import { css, Mode, ModeProvider } from 'canoe';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const Container = styled.div<{ mode: Mode }>`
  ${({ theme, mode }) => css`
    display: flex;

    height: 100%;
    flex-direction: column;

    ${mode === 'Dark'
      ? css`
          background: ${theme.colors.OnyxGrayD10};
          border: 1px solid ${theme.colors.OnyxGrayD10};
        `
      : css`
          background: ${theme.colors.White};
          border: 1px solid ${theme.colors.GlitterGray};
        `}

    border-right: 0;
    border-top: 0;
    box-sizing: border-box;
  `}
`;

const Wrapper = styled.div`
  position: sticky;
  top: 0;
  right: 0;
  bottom: 0;

  z-index: 3;
`;

interface ResponsiveProps {
  children: React.ReactNode;
  id: string;
  mode: Mode;
}
const Responsive: FunctionComponent<ResponsiveProps> = ({
  children,
  id,
  mode,
  ...props
}: ResponsiveProps) => (
  <Wrapper id={id} {...props}>
    <ModeProvider value={{ mode }}>
      <Container mode={mode}>{children}</Container>
    </ModeProvider>
  </Wrapper>
);

export default Responsive;
